import "../../../../App.css"
import { useEffect, useState, useRef } from 'react';
import NavbarVerical from '../../../Navbar/navbarVertical';
import { Card, Form, Row, Col, Button, DropdownButton, Table } from 'react-bootstrap';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { PostInstructions } from "../../../api/instructionupload"

function InstructionUpload() {
    const [instruction, setInstruction] = useState(""); 
    const [document, setDocument] = useState(null); 
    const [errors, setErrors] = useState({});
    const fileInputRef = useRef(null);

    const token =
        typeof window !== "undefined" ? localStorage.getItem("token") : null;

        const validateInstruction = (value) => {
        if (/^\d+$/.test(value)) {
            return "Only numbers are not allowed in instructions";
        }
        return "";
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const newErrors = {};
        if (!document) newErrors.document = "Please upload an instruction file.";
       if (!instruction.trim()) {
            newErrors.instruction = "Please enter an instruction.";
        } else {
            const instructionError = validateInstruction(instruction);
            if (instructionError) newErrors.instruction = instructionError;
        }

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return;
        }

        try {
            const response = await PostInstructions(token, instruction, document);
            toast.success("Instruction uploaded successfully!");
            console.log("Response:", response.data);
            setInstruction("");
            setDocument(null);
            handleCancel();
        } catch (error) {
            console.error("Error uploading instruction:", error);
            toast.error("Failed to upload instruction. Please try again.");
        }
    };

     const handleInstructionChange = (e) => {
        const value = e.target.value;
        setInstruction(value);
        
        if (value.trim()) {
            const instructionError = validateInstruction(value);
            setErrors(prev => ({ 
                ...prev, 
                instruction: instructionError 
            }));
        } else {
            setErrors(prev => ({ ...prev, instruction: "" }));
        }
    };

    const handleCancel = () => {
        setInstruction("");
        setDocument(null);
        setErrors({});
        if (fileInputRef.current) {
            fileInputRef.current.value = null;
        }
    }

    return (
        <>
            <NavbarVerical />
            <div className="content-area">
                <Card>
                    <Card.Body>
                        <p style={{ color: "#6e48aa", fontWeight: "600", borderBottom: "1px solid #6e48aa" }}>Instruction Upload</p>
                        <Form>
                            <Row>
                                <Col>
                                    <Row className="mb-3">
                                        <Form.Label
                                            className="col-sm-3 col-form-label form-label"
                                            htmlFor="courseDropdown"
                                        >
                                            Institute Instruction<span className="text-danger">*</span>
                                        </Form.Label>
                                        <Col sm={7} className="mb-3 mb-lg-0">
                                            <Form.Control
                                                type="file"
                                                ref={fileInputRef}
                                                onChange={(e) => {
                                                    setDocument(e.target.files[0]);
                                                    setErrors(prev => ({ ...prev, document: "" }));
                                                }}
                                            />
                                            {errors.document && (
                                                <div style={{ color: "red", fontSize: "13px", marginTop: "3px" }}>
                                                    {errors.document}
                                                </div>
                                            )}
                                        </Col>
                                    </Row>
                                    <Row className="mb-3">
                                        <Form.Label
                                            className="col-sm-3 col-form-label form-label"
                                            htmlFor="courseDropdown"
                                        >
                                            common Instruction<span className="text-danger">*</span>
                                        </Form.Label>
                                        <Col sm={7} className="mb-3 mb-lg-0">
                                            <Form.Control
                                                as="textarea"
                                                rows={3}
                                                placeholder="Enter Instruction Here ..."
                                                value={instruction}
                                               onChange={handleInstructionChange}
                                            />
                                            {errors.instruction && (
                                                <div style={{ color: "red", fontSize: "13px", marginTop: "3px" }}>
                                                    {errors.instruction}
                                                </div>
                                            )}
                                        </Col>
                                    </Row>

                                </Col>
                            </Row>

                            <Row>
                                <Col className="d-flex align-items-center justify-content-center mb-3 mt-4">
                                    <Button variant="primary" type="button"
                                        onClick={handleSubmit}
                                    >
                                        Submit
                                    </Button>
                                    <ToastContainer />
                                    <Button variant="secondary" type="button" style={{ marginLeft: "10px" }}
                                        onClick={handleCancel}
                                    >
                                        Cancel
                                    </Button>
                                </Col>
                            </Row>

                        </Form>
                    </Card.Body>
                </Card>
            </div>


        </>
    );
}

export default InstructionUpload;